// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"c5666b13","363":"56b1d121","423":"1c2d6f0f","681":"1c3b766c","787":"794cccd5","815":"802e674e","849":"894e5679","992":"a508155b"}[chunkId] + ".chunk.js";
};